import { Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Asset } from '/src/lib/models';

export type AssetValueProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Asset to display value for
   */
  asset?: Asset;
};

export const AssetValue: React.FC<AssetValueProps> = ({ asset, open, toggleOpen }) => {
  return (
    <SidebarItem title="Asset Value" open={open} toggleOpen={toggleOpen} resolved={!!asset}>
      <InfoItem title="Face Value" value={asset?.originalValue ?? 0} currency />
      <InfoItem title="Payments" value={asset?.currentPayments ?? 0} currency />
      <InfoItem title="Adjustments" value={asset?.currentAdjustments ?? 0} currency />
      <Divider />
      <InfoItem title="Current Value" value={asset?.value ?? 0} bold currency />
    </SidebarItem>
  );
};
